import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_image_uploader = _resolveComponent("image-uploader");
  return _ctx.displayImageUploader ? (_openBlock(), _createBlock(_component_image_uploader, {
    key: 0,
    visible: _ctx.displayImageUploader,
    orientation: "square",
    "upload-api-url": _ctx.uploadApiUrl,
    onUploadResult: _ctx.onImageUploaded,
    onClose: _ctx.closeDialog
  }, null, 8, ["visible", "upload-api-url", "onUploadResult", "onClose"])) : _createCommentVNode("", true);
}